export enum CalendarTypes {
    None = 'none',
    Curbside = 'curbsidepickup',
    Delivery = 'delivery',
    Dispatch = 'dispatch',
    Pickup = 'carryout',
    Business = 'business',
}
